<template>
  <div>
    <!-- Calendly inline widget begin -->
    <div
      class="calendly-inline-widget"
      ref="calendlyWidget"
      data-url="https://calendly.com/livratos/30min?primary"
      style="height: 600px"
    ></div>
    <!-- Calendly inline widget end -->
  </div>
</template>

<script>
export default {
  mounted() {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>
